module.exports = __webpack_public_path__ + "img/wait.82b5970d.gif";